import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const MapComponent = ({ regions, onRegionClick, viewMode, speakers }) => {
  const groupSpeakersByCity = (speakers) => {
    const grouped = {};
    speakers.forEach((speaker) => {
      const cityKey = speaker?.city?.arabicName || "غير محددة";
      if (!grouped[cityKey]) grouped[cityKey] = [];
      grouped[cityKey].push(speaker);
    });
    return grouped;
  };

  // ماركر المتحدث الفردي كأفاتار
  const getSpeakerIcon = (imageUrl) =>
    L.divIcon({
      className: "custom-speaker-icon",
      html: `
        <div class="marker-avatar-container" style="background: rgba(107, 114, 224, 0.15); border-radius: 50%; padding: 2px; border: 2px solid #6B72E0; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
          <img src="${imageUrl}" onerror="this.src='/website/assets/default-avatar.png'" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover; background-color: #fff;" />
        </div>
      `,
      iconSize: [35, 35],
      iconAnchor: [17, 17],
      popupAnchor: [0, -17],
    });

  // ماركر المدينة بعدد المتحدثين
  const getCityIcon = (count) =>
    L.divIcon({
      className: "city-marker-icon",
      html: `
        <div style="width: 43px; height: 43px; border-radius: 50%; 
                    background-color: rgba(107, 114, 224, 0.8); color: white; 
                    display: flex; align-items: center; justify-content: center;
                    border: 3px solid white; box-shadow: 0 0 12px rgba(0,0,0,0.4);
                    font-weight: bold; font-size: 13px;">
          ${count}
        </div>
      `,
      iconSize: [43, 43],
      iconAnchor: [21.5, 21.5],
      popupAnchor: [0, -21],
    });

  return (
    <MapContainer
      center={[24.7136, 46.6753]}
      zoom={5}
      style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {viewMode === "individual" &&
        Object.entries(
          speakers.reduce((acc, speaker) => {
            const cityId = speaker?.city?.id || "unknown";
            if (!acc[cityId])
              acc[cityId] = {
                city: speaker.city,
                speakers: [],
              };
            acc[cityId].speakers.push(speaker);
            return acc;
          }, {})
        ).flatMap(([cityId, cityGroup]) => {
          const city = cityGroup.city;
          const citySpeakers = cityGroup.speakers;

          const baseLat = parseFloat(city?.latitude) || 24.7136;
          const baseLng = parseFloat(city?.longitude) || 46.6753;

          const radius = 0.03; // مدى التوزيع العشوائي

          return citySpeakers.map((speaker, index) => {
            const baseDistance = 0.5; // المسافة الابتدائية بين المتحدثين
            const angle = (2 * Math.PI * index) / citySpeakers.length;
            const distance = baseDistance + citySpeakers.length * 0.006; // كل ما زاد العدد زادت المسافة

            const jitterLat = baseLat + distance * Math.cos(angle);
            const jitterLng = baseLng + distance * Math.sin(angle);

            return (
              <Marker
                key={speaker.id}
                position={[jitterLat, jitterLng]}
                icon={getSpeakerIcon(speaker.profileImage)}
              >
                <Popup>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `
      <div class="speaker-popup-content" style="width: 258px;">
        <div class="d-flex align-items-center mb-2">
          <img src="${speaker.profileImage}" alt="${speaker.arabicFullName}" 
            class="me-2" 
            style="width: 50px; height: 50px; border-radius: 50%; object-fit: cover; border: 2px solid #6B72E0; background-color: #fff;" 
            onerror="this.src='/website/assets/default-avatar.png'" />
          <div>
            <h6 class="mb-0 fw-bold">${speaker.arabicFullName}</h6>
            <small class="text-muted">${speaker.arabicJobTitle}</small>
            <div class="mt-1">
              <small><i class="fas fa-map-marker-alt text-danger me-1"></i> ${
                speaker?.city?.arabicName || ""
              }، ${speaker?.city?.state?.country?.arabicName || ""}</small>
            </div>
          </div>
        </div>
        <div class="mb-2 small">${
          speaker.arabicShortBiography || "لا توجد نبذة"
        }</div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div>
            <span class="badge bg-primary-custom me-1">
              <i class="fas fa-star text-warning me-1"></i> 4.8
            </span>
            <small>78 تقييم</small>
          </div>
          <div>
            <small><i class="fas fa-user-friends text-muted me-1"></i> ${
              speaker.profileVisitCount || 0
            }</small>
          </div>
        </div>
        <a href="/speaker-detail/${
          speaker.id
        }" class="btn btn-sm btn-primary-custom w-100">عرض الملف</a>
      </div>
      `,
                    }}
                  />
                </Popup>
              </Marker>
            );
          });
        })}

      {viewMode === "city" &&
        Object.entries(groupSpeakersByCity(speakers)).map(
          ([cityName, citySpeakers], idx) => {
            const lat = citySpeakers[0]?.city?.latitude || 24.7136;
            const lng = citySpeakers[0]?.city?.longitude || 46.6753;

            return (
              <Marker
                key={idx}
                position={[lat, lng]}
                icon={getCityIcon(citySpeakers.length)}
              >
                <Popup>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `
      <div class="city-popup-content" style="width: 220px;">
        <div class="d-flex align-items-center mb-3 pb-2" style="border-bottom: 1px solid #ddd;">
          <div>
            <h5 class="mb-0 fw-bold">${cityName}</h5>
            <div class="text-muted">
              <i class="fas fa-map-marker-alt text-danger me-1"></i> ${
                citySpeakers[0]?.city?.state?.country?.arabicName || ""
              }
            </div>
          </div>
          <div class="ms-auto">
            <span class="badge bg-primary-custom">
              <i class="fas fa-user-tie me-1"></i> ${citySpeakers.length}
            </span>
          </div>
        </div>
        <div class="city-speakers-list" style="max-height: 250px; overflow-y: auto;">
          ${citySpeakers
            .map(
              (s) => `
            <div class="city-speaker-item d-flex align-items-center mb-2 pb-2"
              style="border-bottom: 1px solid #eee; transition: all 0.2s ease; padding: 5px; border-radius: 5px; cursor: pointer;" 
              onmouseover="this.style.backgroundColor='rgba(107, 114, 224, 0.05)'" 
              onmouseout="this.style.backgroundColor='transparent'">
              <img src="${s.profileImage}" 
                alt="${s.arabicFullName}" 
                style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; margin-right: 10px; border: 2px solid #6B72E0; background-color: #fff;" 
                onerror="this.src='/website/assets/default-avatar.png'" />
              <div>
                <div class="fw-bold">${s.arabicFullName}</div>
                <small class="text-muted">${s.arabicJobTitle}</small>
              </div>
              <a href="/speaker-detail/${s.id}" 
                class="btn btn-sm btn-outline-primary ms-auto"
                onmouseover="this.className='btn btn-sm btn-primary ms-auto'"
                onmouseout="this.className='btn btn-sm btn-outline-primary ms-auto'">
                <i class="fas fa-eye"></i>
              </a>
            </div>`
            )
            .join("")}
        </div>
      </div>
      `,
                    }}
                  />
                </Popup>
              </Marker>
            );
          }
        )}
    </MapContainer>
  );
};

export default MapComponent;
